import React from 'react';
import { CVData } from '../../types';
import { BaseTemplate } from './BaseTemplate';
import { generateTemplateColors } from '../../lib/colorUtils';

interface Template7Props {
  data: CVData;
  pageNumber?: number;
  customColor?: string;
}

export function Template7({ data, pageNumber = 1, customColor }: Template7Props) {
  // Asegurarnos de que customColor se use correctamente, verificar si es undefined o null
  const baseColor = customColor && customColor.trim() !== '' ? customColor : '#40E0D0';
  
  console.log("Template7 - Color personalizado recibido:", customColor);
  console.log("Template7 - Color base utilizado:", baseColor);
  
  // Generar colores derivados basados en el color principal
  const colors = generateTemplateColors(baseColor);

  // Verificamos que los colores se generaron correctamente
  console.log("Template7 - Colores generados:", colors);
  console.log("Template7 - Sidebar color from:", colors.sidebarFrom);
  console.log("Template7 - Sidebar color to:", colors.sidebarTo);
  console.log("Template7 - Accent color:", colors.accentColor);

  // Verificamos si hay cursos para mostrar
  const hasCourses = data.courses && data.courses.length > 0;
  
  // Verificamos si es una página de continuación
  const isContinuationPage = (data as any).isContinuationPage || false;
  
  // Verificamos si es una página de continuación específica del caso 3
  const isCase3ContinuationPage = (data as any).isCase3ContinuationPage || false;
  
  // Verificamos si es una página de continuación específica del caso 4
  const isCase4ContinuationPage = (data as any).isCase4ContinuationPage || false;
  
  // Verificamos si es la segunda página del caso 5 (3 experiencias)
  const isCase5SecondPage = (data as any).isCase5SecondPage || false;
  
  // Verificamos si es la tercera página del caso 5 (solo cursos)
  const isCase5ThirdPage = (data as any).isCase5ThirdPage || false;
  
  // Verificamos si es la segunda o tercera página del caso 6
  const isCase6SecondPage = (data as any).isCase6SecondPage || false;
  const isCase6ThirdPage = (data as any).isCase6ThirdPage || false;
  
  // Verificamos si es la segunda página del caso 7
  const isCase7SecondPage = (data as any).isCase7SecondPage || false;
  
  // Verificamos si es la tercera página del caso 7
  const isCase7ThirdPage = (data as any).isCase7ThirdPage || false;
  
  // Verificamos si es la segunda, tercera o cuarta página del caso 8
  const isCase8SecondPage = (data as any).isCase8SecondPage || false;
  const isCase8ThirdPage = (data as any).isCase8ThirdPage || false;
  const isCase8FourthPage = (data as any).isCase8FourthPage || false;
  
  // Verificamos si es una página de continuación con experiencia + cursos
  const isExperiencePlusCourses = (data as any).isExperiencePlusCourses || false;
  
  // Verificamos si es una página de continuación que incluye experiencias
  const isContinuationWithExperiences = (data as any).isContinuationWithExperiences || false;
  
  // Verificamos si es una página de sólo cursos
  const isOnlyCoursesPage = isCase5ThirdPage || isCase8FourthPage || (data as any).isOnlyCoursesPage || false;

  // Verificamos si es una página de continuación para cualquier caso
  const isAnyCaseContinuationPage = isCase3ContinuationPage || isCase4ContinuationPage || 
                                   isCase5SecondPage || isCase5ThirdPage || 
                                   isCase6SecondPage || isCase6ThirdPage || 
                                   isCase7SecondPage || isCase7ThirdPage ||
                                   isCase8SecondPage || isCase8ThirdPage || isCase8FourthPage;

  console.log("Template7 - Es continuación:", isContinuationPage);
  console.log("Template7 - Es página de solo cursos:", isOnlyCoursesPage);
  console.log("Template7 - Hay cursos:", hasCourses);
  console.log("Template7 - Longitud de experiencias:", data.experience?.length || 0);
  console.log("Template7 - Longitud de cursos:", data.courses?.length || 0);
  
  // Optimizar datos para que habilidades se muestren mejor en el sidebar
  // Limitamos la cantidad de habilidades para que no ocupe demasiado espacio
  const optimizedData = {
    ...data,
    skills: data.skills ? data.skills.slice(0, Math.min(5, data.skills.length)) : [],
    // Solo mostramos las principales habilidades
  };
  
  // Función para renderizar los cursos
  const renderCourses = () => {
    if (!data.courses || data.courses.length === 0) {
      console.log("Template7 - No hay cursos para renderizar");
      return null;
    }
    
    console.log("Template7 - Renderizando cursos:", data.courses.length);
    return (
      <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-sm border overflow-hidden" style={{ borderColor: `${colors.accentColor}30` }}>
        <div className="px-6 py-3" style={{ background: `linear-gradient(to right, ${colors.sidebarFrom}10, ${colors.sidebarTo}10)` }}>
          <h3 className="text-lg font-semibold" style={{ color: colors.accentColor }}>Cursos y Certificaciones</h3>
        </div>
        <div className="p-4 space-y-3">
          {data.courses.map((course, index) => (
            <div 
              key={`course-${index}`} 
              className="relative pl-6"
            >
              <span 
                className="absolute left-0 top-2 w-2 h-2 rounded-full" 
                style={{ backgroundColor: colors.accentColor }}
              ></span>
              <h4 className="font-bold text-gray-800">{course.title}</h4>
              <div className="flex items-center justify-between">
                <p className="text-sm" style={{ color: colors.accentColor }}>{course.institution}</p>
                <p className="text-sm ml-2" style={{ color: colors.accentColor }}>{course.period}</p>
              </div>
              {course.description && (
                <p className="text-sm text-gray-600 mt-0.5">{course.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Si es una página solo de cursos, solo mostramos los cursos
  if (isOnlyCoursesPage && hasCourses) {
    console.log("Template7 - Renderizando SOLO cursos sin otro contenido");
    return (
      <BaseTemplate
        data={optimizedData}
        colors={colors}
        isTemplate1={false}
        renderMainContent={() => (
          <div className="space-y-6 pt-4">
            {renderCourses()}
          </div>
        )}
      />
    );
  }
  
  // Si es una página de continuación con experiencias
  if (isAnyCaseContinuationPage && data.experience && data.experience.length > 0) {
    console.log("Template7 - Renderizando continuación con experiencia");
    
    // Determinar si esta página debe mostrar cursos
    const shouldShowCourses = 
      hasCourses && 
      (isCase3ContinuationPage || isCase4ContinuationPage || isCase6ThirdPage || isCase7ThirdPage) && 
      !(isCase5SecondPage || isCase6SecondPage || isCase7SecondPage || 
        isCase8SecondPage || isCase8ThirdPage);
    
    return (
      <BaseTemplate
        data={optimizedData}
        colors={colors}
        isTemplate1={false}
        renderMainContent={(experienceItems) => (
          <div className="space-y-6 pt-4">
            {/* Experiencia continuación */}
            {experienceItems && React.Children.count(experienceItems) > 0 && (
              <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-sm border overflow-hidden" style={{ borderColor: `${colors.accentColor}30` }}>
                <div className="px-6 py-4" style={{ background: `linear-gradient(to right, ${colors.sidebarFrom}10, ${colors.sidebarTo}10)` }}>
                  <h3 className="text-lg font-semibold" style={{ color: colors.accentColor }}>Experiencia Profesional (continuación)</h3>
                </div>
                <div className="p-6 space-y-6">
                  {experienceItems}
                </div>
              </div>
            )}
            
            {/* Cursos y Actividades (para casos específicos) */}
            {shouldShowCourses && renderCourses()}
          </div>
        )}
      />
    );
  }
  
  return (
    <BaseTemplate
      data={optimizedData}
      colors={colors}
      isTemplate1={false}
      renderMainContent={(experienceItems, pageNumber) => (
        <div className="space-y-6">
          {pageNumber === 1 ? (
            <>
              {/* Header con nombre y cargo - SOLO EN PRIMERA PÁGINA */}
              <div className="relative -mx-6 -mt-6 h-24 mb-8 overflow-hidden rounded-br-[100px]">
                <div className="absolute inset-0" style={{ background: `linear-gradient(to right, ${colors.sidebarFrom}, ${colors.sidebarTo})` }} />
                <div className="absolute inset-0" style={{ background: `radial-gradient(circle at 30% 50%, ${colors.sidebarFrom}20, transparent 60%)` }} />
                <div className="absolute bottom-3 left-8 right-8">
                  <h1 className="text-2xl font-bold text-white mb-0.5">{data.name}</h1>
                  <h2 className="text-lg font-bold text-white/90">{data.title}</h2>
                </div>
              </div>

              {/* Contenido Principal */}
              <div className="space-y-6">
                {/* Education Section */}
                <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-sm border overflow-hidden" style={{ borderColor: `${colors.accentColor}30` }}>
                  <div className="px-6 py-4" style={{ background: `linear-gradient(to right, ${colors.sidebarFrom}10, ${colors.sidebarTo}10)` }}>
                    <h3 className="text-lg font-semibold" style={{ color: colors.accentColor }}>Educación</h3>
                  </div>
                  <div className="p-6">
                    <div className="relative">
                      {/* Línea vertical que conecta todos los elementos */}
                      <div 
                        className="absolute left-2 top-0 bottom-0 w-0.5" 
                        style={{ backgroundColor: `${colors.accentColor}40` }}
                      ></div>
                      
                      {/* Contenedor para todos los elementos de educación */}
                      <div className="space-y-4 ml-10">
                        {data.education.map((edu, index) => (
                          <div key={`edu-${index}`} className="relative">
                            {/* Punto en la línea de tiempo */}
                            <div 
                              className="absolute -left-10 top-1.5 w-4 h-4 rounded-full border-2"
                              style={{ 
                                backgroundColor: 'white', 
                                borderColor: colors.accentColor 
                              }}
                            ></div>
                            
                            {/* Contenido de educación */}
                            <div>
                              <h4 className="font-bold text-gray-800">{edu.degree}</h4>
                              <div className="flex items-center justify-between">
                                <p className="text-sm" style={{ color: colors.accentColor }}>{edu.institution}</p>
                                <p className="text-sm ml-2" style={{ color: colors.accentColor }}>{edu.period}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Experience Section */}
                <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-sm border overflow-hidden" style={{ borderColor: `${colors.accentColor}30` }}>
                  <div className="px-6 py-4" style={{ background: `linear-gradient(to right, ${colors.sidebarFrom}10, ${colors.sidebarTo}10)` }}>
                    <h3 className="text-lg font-semibold" style={{ color: colors.accentColor }}>Experiencia Profesional</h3>
                  </div>
                  <div className="p-6">
                    <div className="relative">
                      {/* Línea vertical que conecta todos los elementos */}
                      <div 
                        className="absolute left-2 top-0 bottom-0 w-0.5" 
                        style={{ backgroundColor: `${colors.accentColor}40` }}
                      ></div>
                      
                      {/* Contenedor para todas las experiencias */}
                      <div className="space-y-4 ml-10">
                        {React.Children.map(experienceItems, (item, index) => (
                          <div key={`exp-${index}`} className="relative">
                            {/* Punto en la línea de tiempo */}
                            <div 
                              className="absolute -left-10 top-1.5 w-4 h-4 rounded-full border-2"
                              style={{ 
                                backgroundColor: 'white', 
                                borderColor: colors.accentColor 
                              }}
                            ></div>
                            {item}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {/* Contenido de la segunda página - SIN HEADER */}
              <div className="space-y-6 pt-4">
                {/* Experiencia laboral (continuación) - Solo si hay elementos */}
                {experienceItems && React.Children.count(experienceItems) > 0 && (
                  <div className="p-4 mb-5">
                    <h3 className="text-xl font-medium mb-4 border-b-2 border-gray-300 pb-2" style={{ color: colors.accentColor }}>Experiencia Profesional (continuación)</h3>
                    <div className="relative">
                      {/* Línea vertical que conecta todos los elementos */}
                      <div 
                        className="absolute left-2 top-0 bottom-0 w-0.5" 
                        style={{ backgroundColor: `${colors.accentColor}40` }}
                      ></div>
                      
                      {/* Contenedor para todas las experiencias */}
                      <div className="space-y-6 ml-10">
                        {React.Children.map(experienceItems, (item, index) => (
                          <div key={`exp-cont-${index}`} className="relative">
                            {/* Punto en la línea de tiempo */}
                            <div 
                              className="absolute -left-10 top-1.5 w-4 h-4 rounded-full border-2"
                              style={{ 
                                backgroundColor: 'white', 
                                borderColor: colors.accentColor 
                              }}
                            ></div>
                            {item}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
                
                {/* Cursos y Actividades Adicionales */}
                {hasCourses && !isCase5SecondPage && !isCase6SecondPage && !isCase7SecondPage && 
                 !isCase8SecondPage && !isCase8ThirdPage && renderCourses()}
              </div>
            </>
          )}
        </div>
      )}
    />
  );
}